module.exports = __webpack_public_path__ + "static/media/S2E_pic.10a10d48.png";